export const listWrapperStyles = {
  width: "50%",
  maxWidth: 150,
  position: "absolute",
  top: 0,
  left: 0,
};

export const imageMetricStyles = {
  width: { xs: "50%" },
  ml: 'auto',
  maxWidth: { xs: 312 },
  height: "auto",
  objectFit: "contain",
};

export const getListStyles = (isSmallMobile: boolean) => ({
  display: "flex",
  gap: { xs: isSmallMobile ? 0.5 : 1, lg: 2 },
  flexWrap: "wrap",
});

export const listItemStyles = {
  py: { xs: 0.5, lg: 1.25 },
  px: { xs: 1, lg: 2 },
  border: "1px solid #E0E0E0",
  borderRadius: 3,
  whiteSpace: "nowrap",
  width: "fit-content",
};

export const imageReportStyles = {
  width: { xs: "100%" },
  maxWidth: { xs: 312, md: 716 },
  height: "auto",
  objectFit: "contain",
  mx: "auto",
};

export const imageWrapperScoreStyles = {
  height: "100%",
  border: "1px solid #E4E5E9",
  boxSizing: "border-box",
  borderRadius: "20px",
};

export const imageScoreStyles = {
  width: { xs: "100%", lg: 238, xl: 286 },
  height: "auto",
  objectFit: "contain",
};

export const imageWrapperStatStyles = {
  border: {
    xs: "1px solid transparent",
    sm: "1px solid #E4E5E9",
  },
  boxSizing: "border-box",
  borderRadius: "20px",
};

export const imageStatStyles = {
  width: { xs: "100%", lg: 280, xl: 342 },
  maxWidth: { xs: 312, xl: 342 },
  height: "auto",
  objectFit: "contain",
};

// ---------- Slider styles --------------
export const wrapperStyles = {
  position: "sticky",
  top: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  boxSizing: "border-box",
  height: { xs: 500, lg: 760 },
};

export const slideContainerStyles = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  transform: { xs: "translateY(-30px)", md: "translateY(-0px)" },
};

export const getSlideStyles = (isSmallMobile: boolean) => ({
  position: "absolute",
  height: "70%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transformOrigin: "50% 50%",
  paddingLeft: isSmallMobile ? "16px" : "24px",
  paddingRight: isSmallMobile ? "16px" : "24px",
});

export const slideCardStyles = {
  position: "relative",
  maxWidth: 1440,
  boxSizing: "border-box",
  width: "100%",
  height: "100%",
};
